export const BILLING_ALLOWED_ROLES = Object.freeze([
  'admin',
  'dispatcher',
  'economist',
]);

export const canAccessBilling = (role) => BILLING_ALLOWED_ROLES.includes(role);
